<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Reportes</ion-title>
    </ion-toolbar>
    <ion-progress-bar type="indeterminate" v-if="!datos||cargando"></ion-progress-bar>
  </ion-header>
  <ion-content class="content">
    <ion-row>
      <ion-col size-xs="12" size-sm="4" size-md="3">
        <ion-list>
          <ion-item>
            <ion-label position="floating">Desde fecha</ion-label>
            <ion-input :debounce="debounce" type="date" :value="desdeFecha" v-on:ionChange="desdeFecha=$event.detail.value"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Hasta fecha</ion-label>
            <ion-input :debounce="debounce" type="date" :value="hastaFecha" v-on:ionChange="hastaFecha=$event.detail.value"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Tipo de reporte</ion-label>
            <ion-select :debounce="debounce" :value="tipoReporte" v-on:ionChange="tipoReporte=$event.detail.value">
              <ion-select-option v-for="u in tiposReportes" :key="u">{{u}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item @click="seleccionarCliente">
            <ion-label position="stacked">Cliente</ion-label>
            <ion-input readonly color="primary" :value="(cliente).nombre || 'Todos'" />
          </ion-item>
          <ion-item v-if="idCliente!='' && proyectos.length>0" :color="highlightIdProyecto?'medium':''">
            <ion-label position="floating">Proyecto</ion-label>
            <ion-select :debounce="debounce" :value="idProyecto" v-on:ionChange="idProyecto=$event.detail.value">
              <ion-select-option :value="''">Todos</ion-select-option>
              <ion-select-option v-for="u in proyectos" :value="u._id" :key="u._id">{{u.nombre}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Mostrar usuario</ion-label>
            <ion-select :debounce="debounce" :value="idUsuario" v-on:ionChange="idUsuario=$event.detail.value">
              <ion-select-option :value="''">Todos</ion-select-option>
              <ion-select-option v-for="u in catalogos.usuarios" :value="u._id" :key="u._id">{{u.nombre}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Mostrar equipo</ion-label>
            <ion-select :debounce="debounce" :value="idEquipo" v-on:ionChange="idEquipo=$event.detail.value">
              <ion-select-option :value="''">Todos</ion-select-option>
              <ion-select-option v-for="u in catalogos.equipos.filter(e=>(idCliente==''||e.idCliente==idCliente))" :value="u._id" :key="u._id">{{u.sn}} {{u.marca}} {{u.modelo}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
      <ion-col size-xs="12" size-sm="8" size-md="9">
        <LineChart v-if="datacollection && tipoReporte==''" :chart-data="datacollection" />
        <div v-if="datos">
          <ReporteDashboard :datos="datos" v-if="tipoReporte=='Dashboard'" :catalogos="catalogos" />
          <ReporteTiposDeServicio :datos="datos" v-if="tipoReporte=='Tipos y costos de servicio'" :catalogos="catalogos" />
          <ReporteTiempo :datos="datos" v-if="tipoReporte=='Tiempo dedicado al servicio'" :catalogos="catalogos" />
          <ReporteLista :datos="datos" v-if="tipoReporte=='Lista de servicios'" :catalogos="catalogos" />
        </div>
      </ion-col>
    </ion-row>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
import LineChart from '@/components/Extras/LineChart.vue'
import ReporteDashboard from './ReporteDashboard'
import ReporteTiposDeServicio from './ReporteTiposDeServicio'
import ReporteTiempo from './ReporteTiempo'
import ReporteLista from './ReporteLista'
import ModalSeleccionarCliente from '@/components/ModalSeleccionarCliente'
export default {
  name: 'ReportesHandler',
  data() {
    return {
      cargando: true,
      catalogos: {
        equipos: [],
        clientes: [],
        usuarios: []
      },
      cliente: {},
      tiposReportes: [
        'Dashboard',
        'Tipos y costos de servicio',
        'Tiempo dedicado al servicio',
        'Lista de servicios'
        /*'Servicios concluídos',
        'Tipos de incidente',
        'Utilidad',
        'Servicios bajo contrato',
        'Servicios espontáneos',
        'Altas y bajas' //*/
      ],
      //
      debounce: 500,
      desdeFecha: new Date().toISOString().substring(0, 7) + '-01',
      hastaFecha: new Date(new Date().getTime() + (1000 * 60 * 60 * 24)).toISOString().substring(0, 10),
      tipoReporte: 'Dashboard',
      idCliente: '',
      idProyecto: '',
      highlightIdProyecto: false,
      idUsuario: '',
      idEquipo: '',
      //
      datos: null,
      datacollection: null,
      modal: null
    }
  },
  components: {
    LineChart,
    ReporteDashboard,
    ReporteTiposDeServicio,
    ReporteTiempo,
    ReporteLista
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    fillData() {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()],
        datasets: [{
          label: 'Data One',
          backgroundColor: '#f87979',
          data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
        }, {
          label: 'Data One',
          backgroundColor: '#f87979',
          data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
        }]
      }
    },
    async obtener() {
      //if (!this.cargando)
      {
        this.cargando = true
        this.datos = null
        let datos = {
          desdeFecha: this.desdeFecha,
          hastaFecha: this.hastaFecha,
          ordenes: [],
          costos: [],
          terminados: 0,
          inventariados: [],
          tiempoCompletado: 0,
          porCliente: {},
          porAutor: {},
          porEquipo: {}
        }
        let filtros = [
          'fecha,gte,' + new Date(this.desdeFecha).getTime(),
          'fecha,lt,' + new Date(this.hastaFecha).getTime()
        ]
        let subset = [{
          coleccion: 'equipo',
          query: '_id,eq,',
          sustituir: 'idEquipo'
        }, {
          coleccion: 'cliente',
          query: '_id,eq,',
          sustituir: 'idCliente'
        }, {
          coleccion: 'directorio',
          alias: 'autor',
          query: '_id,eq,',
          sustituir: 'idAutor'
        }]
        if (this.idCliente != '')
          filtros.push('idCliente,eq,' + this.idCliente)
        if (this.idUsuario != '')
          filtros.push('idAutor,eq,' + this.idUsuario)
        if (this.idEquipo != '')
          filtros.push('idEquipo,eq,' + this.idEquipo)
        const idProyecto = this.idProyecto
        datos.ordenes = (await Api.find('ordenservicio', filtros, {
            subset
          }))
          .filter(o => idProyecto == '' || o.idProyecto == idProyecto)
        console.log("PRE ordenes", filtros, datos.ordenes)
        //
        for (let orden of datos.ordenes) {
          // Cuentas
          if (orden.terminada)
            datos.terminados++
          if (orden.equipo) {
            if (orden.equipo.inventariable)
              datos.inventariados.push(orden._id)
          }
          if (orden.costos)
            datos.costos = datos.costos.concat(orden.costos)
          // Tiempo invertido
          let ordenTemporizada = JSON.parse(JSON.stringify(orden))
          //if (!orden.fechaTerminada) orden.fechaTerminada = new Date().getTime()
          orden.fechaCreada = new Date(orden.fechaCreada || orden.fecha).getTime()
          datos.tiempoCompletado += ((orden.fechaTerminada || new Date().getTime()) - orden.fechaCreada)
          // Grupos
          if (orden.cliente) {
            let label = orden.cliente.alias || orden.cliente.nombre
            if (!datos.porCliente[label])
              datos.porCliente[label] = []
            datos.porCliente[label].push(orden)
          }
          if (orden.autor) {
            let label = orden.autor.alias || orden.autor.nombre
            if (!datos.porAutor[label])
              datos.porAutor[label] = []
            datos.porAutor[label].push(orden)
          }
          if (orden.equipo) {
            let label = orden.equipo.marca + ' ' + orden.equipo.modelo + ' ' + orden.equipo.sn
            if (!datos.porEquipo[label])
              datos.porEquipo[label] = []
            datos.porEquipo[label].push(orden)
          }
        }
        if (datos.costos && datos.costos.length > 0)
          datos.totalCostos = datos.costos.reduce((acum, obj) => acum + (obj.cantidad * obj.precioUnitario))
        //
        await Api.wait(500)
        this.datos = datos
      }
      await Api.wait(200)
      this.cargando = false
      console.log("Datos obtenidos", JSON.parse(JSON.stringify(this.datos)))
    },
    async seleccionarCliente() {
      let vm = this
      let clientes = this.clientes
      let id = 'seleccionarCliente'
      console.log("ModalSeleccionarCliente", clientes)
      return this.$ionic.modalController
        .create({
          component: ModalSeleccionarCliente,
          swipeToClose: true,
          componentProps: {
            parent: vm,
            propsData: {
              clientes: this.catalogos.clientes,
              mostrarItemTodos: true
            }
          }
        })
        .then(m => {
          vm.modal = m
          console.log("ModalSeleccionarCliente", vm.modal)
          vm.modal.present()
          vm.modal.onDidDismiss(_ => {
            console.log("seleccionarCliente Modal cerrado")
            Api.$off('ModalSeleccionarClienteCerrar')
            Api.$off('seleccionarCliente')
          })
          Api.$on('ModalSeleccionarClienteCerrar', _ => {
            console.log("$on ModalSeleccionarClienteCerrar")
            vm.modal.dismiss()
          })
          Api.$on('seleccionarCliente', async c => {
            //vm.orden.idCliente = c._id
            vm.modal.dismiss()
            vm.idCliente = c._id
            vm.cliente = c
            vm.proyectos = await Api.find('proyectoorden', ['idCliente,eq,' + c._id])
            vm.highlightIdProyecto = true
            await Api.wait(1500)
            vm.highlightIdProyecto = false
            toast("Cliente seleccionado: " + c.nombre)
            vm.$forceUpdate()
            console.log("$on seleccionarCliente", c.nombre)
          })
        })
    },

  },
  watch: {
    'idCliente': function(a) {
      console.log("$watch idCliente", a)
      this.obtener()
    },
    'idProyecto': function(a) {
      console.log("$watch idProyecto", a)
      this.obtener()
    },
    'idEquipo': function(a) {
      console.log("$watch idEquipo", a)
      this.obtener()
    },
    'idUsuario': function(a) {
      console.log("$watch idUsuario", a)
      this.obtener()
    },
    'desdeFecha': function(a) {
      console.log("$watch desdeFecha", a)
      this.obtener()
    },
    'hastaFecha': function(a) {
      console.log("$watch hastaFecha", a)
      this.obtener()
    },
  },
  async mounted() {
    this.catalogos.usuarios = (await Api.get('directorio'))
      .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
    this.catalogos.clientes = (await Api.get('cliente'))
      .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
      .filter(c => c.nombre && c.nombre != '')
    this.catalogos.equipos = (await Api.get('equipo'))
      .sort((a, b) => a.sn > b.sn ? 1 : -1)
    console.log("Catalogos", this.catalogos)
    this.fillData()
    await Api.wait(100)
    this.obtener()
  }
}
</script>
